import React, { useCallback, useContext } from 'react'
import _ from 'lodash'
import { dataFix } from 'global/common/dataFix';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { gEnums } from 'global/enums/globalEnums';
import { playoffBracketTypes } from '../elements/matches/PlayoffBracket';
import { matchSequence } from '../helpers/matchSequence';

const matchSeeds = {
  work: 'work'
}

export const useTournamentData = () => {

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns

  const appendTournament = useCallback(({ tournament }) => {
    append_tournament(tournament);
  }, []);

  const createRoundInfo = useCallback(({ playoffOnly, sportsDetails, seededTeams }) => {
    return create_roundInfo(playoffOnly, sportsDetails, seededTeams);
  }, []);

  const createTournamentInfo = useCallback(({ playoffOnly, state, callback }) => {
    return create_tournamentInfo(playoffOnly, state, callback, database_fns);
  }, []);

  return { appendTournament, createRoundInfo, createTournamentInfo }
}

const create_tournamentInfo = (playoffOnly, state, callback, database_fns) => {

  const _asat = gEnums.availableSubActionTypes
  const { teams_selected, seededTeams, playoff_info } = state
  let { subActionType } = state
  const { playoffLevelTeams, playoffDates_selected } = playoff_info ?? {}

  let { sportsDetails } = state

  subActionType = _asat.createPlayoff

  switch (subActionType) {
    case _asat.createTournament:
      const tournament = {
        tournamentTeams: teams_selected,
        teams: seededTeams,
        roundInfo: create_roundInfo(playoffOnly, sportsDetails, seededTeams),
        isPlayoff: playoffOnly
      }
      append_tournament(tournament)
      callback && callback(tournament)
      return { tournament }

    case _asat.createPlayoff:
      if (playoffLevelTeams) {
        const tournaments = {}
        Object.keys(playoffLevelTeams).forEach(key => {
          const teams = playoffLevelTeams[key]
          const selectedDates = playoffDates_selected[key]
          if (!sportsDetails) { sportsDetails = {} }
          sportsDetails.tournamentTeamCount = teams.length
          const _tournament = {
            selectedDates,
            tournamentTeams: teams,
            teams: teams,
            roundInfo: create_roundInfo(playoffOnly, sportsDetails, teams),
            isPlayoff: true,
            levels: key
          }
          try {
            append_tournament(_tournament)
            tournaments[key] = _tournament
          } catch (error) {
            console.log('_tournament error', error)
          }
        })
        const { playoffMatches, tournamentMatches } = getPlayoffMatches(database_fns, tournaments)
        appendTournamentMatches_pending2(tournaments, playoffMatches)
        callback && callback(tournaments, playoffMatches, tournamentMatches)
        return { tournaments, playoffMatches, tournamentMatches }
      }
      break;
    default:
      break;
  }
}


const append_tournament = (tournament) => {
  tournament.rounds = {}
  createRounds(tournament)
}

const getPlayoffRounds = (numTeams) => {
  return Math.ceil(Math.log2(numTeams));
};

const create_roundInfo = (playoffOnly, sportsDetails, seededTeams) => {

  const rc = getPlayoffRounds(_.size(seededTeams))

  const { roundCount, teamsPerPool, maxPlayoffTeams } = sportsDetails ?? {}
  const roundInfo = {}

  if (!playoffOnly) {
    for (var r = 1; r <= roundCount; r++) {
      const prefix = 'round' + r
      let isInitialPool = (r === 1) ? true : false
      if (!roundInfo[prefix]) { roundInfo[prefix] = {} }
      roundInfo[prefix].maxTeams = teamsPerPool
      roundInfo[prefix].setsPerMatch = 3
      roundInfo[prefix].pointsPerSet = 25
      roundInfo[prefix].bestOf = true
      roundInfo[prefix].isPlayoff = false
      roundInfo[prefix].isInitialPool = isInitialPool
      roundInfo[prefix].teams = seededTeams
      roundInfo[prefix].tournamentTeamCount = Object.keys(seededTeams).length
    }
  }
  ammendPlayoffInfo(roundInfo, maxPlayoffTeams, seededTeams)
  return roundInfo
}


/** Create rounds for a tournament */
const createRounds = (tournament) => {

  if (!tournament) return;

  // reset the maxTeams 
  let max = 0

  Object.keys(tournament.roundInfo).forEach((riKey, roundIndex) => {
    const roundInfo = tournament.roundInfo[riKey]
    max = max + roundInfo.maxTeams
  })

  Object.keys(tournament.roundInfo).forEach((riKey, roundIndex) => {
    const roundInfo = tournament.roundInfo[riKey]
    createRound(tournament, roundInfo, roundIndex)
  })
}

const createRound = (tournament, roundInfo, roundIndex) => {

  const { teams: tournamentTeams } = tournament ?? {}

  // create the round
  const round = {}

  const tournamentTeamCount = Object.keys(tournamentTeams).length

  // new 
  roundInfo.realRoundIndex = (roundIndex + 1)

  const { realRoundIndex, maxTeams, isPlayoff } = roundInfo

  round.roundKey = isPlayoff ? 'playoffs' : 'round' + realRoundIndex
  round.itemIndex = realRoundIndex
  round.name = (roundInfo.isPlayoff) ? 'Playoffs' : 'Round ' + realRoundIndex

  if (tournamentTeamCount > 0) {

    roundInfo.poolsInRound = (maxTeams) ? Math.round(tournamentTeamCount / maxTeams) : 0

    if (realRoundIndex === 1) {
      round.seeds = getRoundSeeds(tournamentTeams, round.seeds)
    }

    // new POOLS
    round.pools = {}

    addTeamsToPools(tournament, round, roundInfo, tournamentTeamCount)
    createMatches(tournament, round, roundInfo)
  }

  tournament.rounds[round.roundKey] = round

  // getPoolSeedTotals(tournament)
}

const getRoundSeeds = (teams) => {
  const seeds = {}
  _.forEach(teams, (team) => {
    const { seed, position, id, _itemKey } = team
    const _seed = seed ? seed : position
    const _id = _itemKey || id
    seeds[_seed] = {
      id: _id,
      _itemKey: _id,
      name: team.name,
      seed: _seed
    }
  })
  return seeds
}

const addTeamsToPools = (tournament, round, roundInfo, tournamentTeamCount) => {

  const { isInitialPool, isPlayoff } = roundInfo ?? {}

  if (isInitialPool && !isPlayoff) {
    addInitialPoolTeams(round, roundInfo, tournamentTeamCount)
  } else if (isPlayoff) {
    addPlayoffPoolTeams(tournament, round, roundInfo, tournamentTeamCount)
  } else {
    addPostInitialRoundPoolTeams(round, roundInfo, tournamentTeamCount)
  }
}

const createMatches = (tournament, round, roundInfo) => {
  const { pools } = round ?? {}
  _.each(pools, (pool) => {
    const { teams } = pool ?? {}
    const teamCount = _.size(teams)
    if (!roundInfo.isPlayoff) {
      pool.matches = createPoolMatches(tournament, teamCount, pool, round)
      pool.startDate = (tournament.isPlayoff) ? tournament.selectedDates[index] : ''
      assignMatchTeamsToSeeds(tournament, round, pool, roundInfo)
      assignWorkTeam(pool)
    }

  })
}

const createPoolMatches = (tournament, teamsPerPool, pool, round) => {

  const poolMatches = {}
  const matchOrders = matchSequence.normal[teamsPerPool]

  matchOrders && Object.keys(matchOrders).forEach((matchOrderKey, index) => {

    const matchOrder = matchOrders[matchOrderKey]
    const matchNumber = index + 1

    const homeSeed = matchOrder[0]
    const awaySeed = matchOrder[1]
    const workSeed = matchOrder[2]

    // always 3 matchOrder (home, away, work)
    const homeTeam = getPoolTeamInfo(pool, homeSeed)
    const awayTeam = getPoolTeamInfo(pool, awaySeed)
    const workTeam = getPoolTeamInfo(pool, workSeed)

    const match = {
      name: 'match ' + matchNumber,
      matchNumber: matchNumber,
      courtNumber: pool.courtNumber,

      away: {
        id: awayTeam.id,
        name: awayTeam.name
      },

      home: {
        id: homeTeam.id,
        name: homeTeam.name
      },

      work: {
        id: workTeam.id,
        name: workTeam.name
      },

      seeds: {
        away: awayTeam.seed,
        home: homeTeam.seed,
        work: workTeam.seed,
      },
    }

    if (!tournament.isPlayoff) {
      match.seeds.work = workTeam.seed
    }

    poolMatches['match' + (index + 1)] = match
  })

  return poolMatches

}

const assignMatchTeamsToSeeds = (tournament, round, pool, roundInfo, otherRound) => {

  let initialSet = false

  const { tournamentTeams } = tournament ?? {}
  const { matches } = pool ?? {}

  // loop the matches
  _.forEach(matches, (match) => {

    const { seeds, isConsolation } = match ?? {}
    const { away: awaySeed, home: homeSeed } = seeds ?? {}

    if ((roundInfo.isInitialPool || tournament.isPlayoff) && !tournament.initialSet) {

      match.home = (round.seeds[homeSeed]) ? round.seeds[homeSeed] : { name: 'BYE' } // , id: homeSeed
      match.away = (round.seeds[awaySeed]) ? round.seeds[awaySeed] : { name: 'BYE' } // , id: awaySeed 

      if (tournament.isPlayoff) {

        initialSet = true

        if (round.itemIndex === 1) {

          const team_away = _.find(tournamentTeams, { name: match.away.name })
          const team_home = _.find(tournamentTeams, { name: match.home.name })

          if (team_away) {
            match.away.sections = team_away.sections
            match.away.levels = team_away.levels
          }

          if (team_home) {
            match.home.sections = team_home.sections
            match.home.levels = team_home.levels
          }

          if (!team_away && !team_home) {
            match.doubleBye = true
          }

          match.location = match.home
        }

      } else {
        match.work = (round.seeds[matchSeeds.work]) ? round.seeds[matchSeeds.work] : ''
      }

      match.teams = []

      if (match.home.id) { match.teams.push(match.home.id) }
      if (match.away.id) { match.teams.push(match.away.id) }
      // match.teams = [match.home.id, match.away.id]

      if (match.home.sections === match.away.sections) {
        match.sectionMeeting = true
      }

    } else {

      match.home = ''
      match.away = ''
      match.work = ''

      // add pending
      if (roundInfo.isPlayoff && otherRound) {
        match.pending = {
          home: findPlayoffSeedInfo(round, pool.itemIndex, homeSeed, isConsolation),
          away: findPlayoffSeedInfo(round, pool.itemIndex, awaySeed, isConsolation)
        }
      } else {
        match.pending = {
          home: findRoundPoolSeedInfo(tournament, round.itemIndex, homeSeed),
          away: findRoundPoolSeedInfo(tournament, round.itemIndex, awaySeed)
        }
      }

      if (!tournament.isPlayoff) {
        match.pending.work = findRoundPoolSeedInfo(tournament, round.itemIndex, matchSeeds.work)
      }
    }

  })

  if (!tournament.initialSet) {
    tournament.initialSet = initialSet
  }

}

const getPoolTeamInfo = (pool, teamPoolNumber) => {

  let realTeamPoolNumber = teamPoolNumber

  if (teamPoolNumber.winnerOf) {
    realTeamPoolNumber = teamPoolNumber.winnerOf
  } else if (teamPoolNumber.loserOf) {
    realTeamPoolNumber = teamPoolNumber.loserOf
  } else if (teamPoolNumber.split) {
    realTeamPoolNumber = teamPoolNumber.split
  } else if (teamPoolNumber.splitWinners) {
    realTeamPoolNumber = teamPoolNumber.split
  } else if (teamPoolNumber.splitWinners || teamPoolNumber.splitLosers) {
    if (teamPoolNumber.splitWinners) {
      // teamName = 'winners split'
    } else {
      // teamName = 'losers split'
    }
  }

  // get the team name
  const seededTeam = _.find(pool.teams, { teamNumber: realTeamPoolNumber })

  const teamInfo = {
    seed: seededTeam ? seededTeam.seed : teamPoolNumber
  }

  return teamInfo

}

const findPlayoffSeedInfo = (round, poolIndex, seed, isConsolation) => {

  let seedInfo = {
    round: null,
    pool: null,
    matchNumber: null,
    place: null,
    originalSeed: 0
  }

  Object.keys(round.pools).forEach((poolKey, index) => {
    const pool = round.pools[poolKey]
    if ((index + 1) === (poolIndex - 1)) {
      const { matches } = pool ?? {}
      Object.keys(matches).forEach(key_match => {
        const match = matches[key_match]
        // winner
        const { matchNumber, seeds, matchKey: match_key } = match ?? {}
        const { home, away } = seeds ?? {}
        if (home === seed || away === seed) {
          seedInfo.round = round.itemIndex
          seedInfo.roundKey = round.roundKey
          seedInfo.pool = pool.itemIndex
          seedInfo.poolKey = poolKey
          seedInfo.poolName = pool.altNameAbr
          seedInfo.matchNumber = matchNumber
          seedInfo.matchKey = key_match
          seedInfo.originalSeed = seed
          seedInfo.place = 'winner'
          seedInfo.match_key = match_key
          if (isConsolation) {
            seedInfo.place = 'loser'
          }
        }
      })
    }
  })

  return seedInfo

}

const addInitialPoolTeams = (round, roundInfo, tournamentTeamCount) => {

  let seedInc = 0
  let poolInc = 0
  let poolAsc = true

  // loop the poolTeamCount
  for (var tc = 0; tc <= tournamentTeamCount - 1; tc++) {

    let pool = null

    seedInc++

    // changed the pool number up and back in the first round
    if (poolAsc) {
      poolInc++
    } else {
      poolInc--
    }

    if (poolInc > roundInfo.poolsInRound) {
      poolInc = roundInfo.poolsInRound
      poolAsc = false
    } else if (poolInc < 1) {
      poolInc = 1
      poolAsc = true
    }

    const poolName = 'pool' + poolInc

    // create the pool
    if (round.pools[poolName] === undefined) {
      pool = {
        itemIndex: poolInc,
        name: 'pool ' + poolInc, // + String.fromCharCode(64 + poolInc),
        courtNumber: poolInc,
        teams: {},
      }
      round.pools[poolName] = pool
    } else {
      pool = round.pools[poolName]
    }

    const teamNumber = Object.keys(pool.teams).length + 1

    // add the team
    pool.teams['team' + teamNumber] = {
      teamNumber: teamNumber,
      seed: seedInc,
      ...round.seeds[seedInc]
    }
  }
}

const addPlayoffPoolTeams = (tournament, round, roundInfo, tournamentTeamCount) => {

  let _roundCount = 1
  let pc = 0
  let teamPlayoffRoundCount = roundInfo.maxTeams
  let otherRound = false
  let roundNames = []
  let roundNamesAbr = []

  switch (roundInfo.maxTeams) {
    case 32:
      _roundCount = 5
      roundNames = [playoffBracketTypes.roundOf32, playoffBracketTypes.roundOf16, playoffBracketTypes.quarterFinals, playoffBracketTypes.semiFinals, playoffBracketTypes.finals]
      roundNamesAbr = ['R32', 'R16', 'QF', 'SF', 'F']
      break;
    case 16:
      _roundCount = 4
      roundNames = [playoffBracketTypes.roundOf16, playoffBracketTypes.quarterFinals, playoffBracketTypes.semiFinals, playoffBracketTypes.finals]
      roundNamesAbr = ['R16', 'QF', 'SF', 'F']
      break;
    case 8:
      _roundCount = 3
      roundNames = [playoffBracketTypes.quarterFinals, playoffBracketTypes.semiFinals, playoffBracketTypes.finals]
      roundNamesAbr = ['QF', 'SF', 'F']
      break;
    case 4:
      _roundCount = 2
      roundNames = [playoffBracketTypes.semiFinals, playoffBracketTypes.finals]
      roundNamesAbr = ['SF', 'F']
      break;
    case 2:
      _roundCount = 1
      roundNames = ['Finals']
      roundNamesAbr = ['F']
      break;
    default:
    // nothing
  }

  const firstRound = roundNames[0]

  // loop the ROUNDS
  for (var prc = 1; prc <= _roundCount; prc++) {

    pc++

    const pn = 'pool' + pc
    let poolKey = roundNames[prc - 1]
    let altNameAbr = roundNamesAbr[prc - 1]

    // get the number of teams in the round
    switch (poolKey) {
      case playoffBracketTypes.roundOf32:
        teamPlayoffRoundCount = 32
        break;
      case playoffBracketTypes.roundOf16:
        teamPlayoffRoundCount = 16
        break;
      case playoffBracketTypes.quarterFinals:
        teamPlayoffRoundCount = 8
        break;
      case playoffBracketTypes.semiFinals:
        teamPlayoffRoundCount = 4
        break;
      case playoffBracketTypes.finals:
        teamPlayoffRoundCount = 2
        break;
      default:
      // nothing
    }

    // create a new POOL
    const pool = {
      itemIndex: pc,
      name: pn,
      poolKey,
      altNameAbr: altNameAbr,
      courtNumber: 'TBD',
      teams: {},
      startDate: (tournament.isPlayoff && tournament.selectedDates) ? tournament.selectedDates[pc - 1] : null
    }

    // add the pool to the round
    round.pools[_.camelCase(poolKey)] = pool

    // loop the number of team in the ROUND
    for (var tc = 1; tc <= teamPlayoffRoundCount; tc++) {
      if (tc <= tournamentTeamCount) {
        pool.teams['team' + tc] = {
          teamNumber: tc,
          seed: tc,
        }
      }
    }

    // the matches in the pools may not have teams at this point, only thier seeds.
    pool.matches = createPlayoffPoolSeedMatches(tournament, pool, round, teamPlayoffRoundCount, firstRound)

    otherRound = (prc !== 1) ? true : false
    assignMatchTeamsToSeeds(tournament, round, pool, roundInfo, otherRound)
  }
}

const addPostInitialRoundPoolTeams = (round, roundInfo, tournamentTeamCount) => {

  let currentTeamSeed = 1
  let teamCount = 0
  let remaining = roundInfo.poolsInRound * roundInfo.maxTeams
  let pool = null
  let maxTeams = roundInfo.maxTeams
  let poolsRemaining = roundInfo.poolsInRound

  for (var pc = 1; pc <= roundInfo.poolsInRound; pc++) {

    const poolName = 'pool' + pc

    if ((poolsRemaining * maxTeams) !== remaining) {
      console.log('We have a problem')
      maxTeams--
    }

    // create the pool if it doesn't exist
    if (round.pools[poolName] === undefined) {
      pool = {
        itemIndex: pc,
        name: 'pool ' + pc,
        courtNumber: pc,
        teams: {}
      }
      round.pools[poolName] = pool
      poolsRemaining--
    } else {
      // set the pool
      pool = round.pools[poolName]
    }

    // add teams to the pool
    for (var tc = 1; tc <= maxTeams; tc++) {
      pool.teams['team' + tc] = {
        teamNumber: tc,
        seed: currentTeamSeed,
      }
      teamCount++
      currentTeamSeed++
    }
    remaining = tournamentTeamCount - teamCount
  }
}

const assignWorkTeam = (pool) => {
  Object.keys(pool.matches).forEach((key_match, matchNumber) => {
    const match = pool.matches[key_match]
    const work = match.work
    if (work.split) {
      Object.keys(pool.matches).forEach((matchKey2, matchIndex2) => {
        if ((matchIndex2 + 1) === work.split) {
          match.work = pool.matches[matchKey2].away + '/' + pool.matches[matchKey2].home
        }
      })
    }
  })
}

const findRoundPoolSeedInfo = (tournament, roundIndex, seed) => {

  let seedInfo = {
    round: null,
    pool: null,
    place: null,
    originalSeed: 0,
  }

  Object.keys(tournament.rounds).forEach((roundKey, index1) => {
    if ((index1 + 1) === (roundIndex - 1)) {
      const round = tournament.rounds[roundKey]
      Object.keys(round.pools).forEach(poolKey => {
        const pool = round.pools[poolKey]
        Object.keys(pool.teams).forEach(teamKey => {
          const team = pool.teams[teamKey]
          if (team.seed === seed) {
            seedInfo.round = round.itemIndex
            seedInfo.pool = pool.itemIndex
            seedInfo.place = team.teamNumber
            seedInfo.originalSeed = seed
          }
        })
      })
    }
  })
  return seedInfo
}

const createPlayoffPoolSeedMatches = (tournament, pool, round, teamPlayoffRoundCount, firstRound) => {

  const poolMatches = {}

  // matchOrders are an array of 3 number [homeSeed, awaySeed, workSeed]
  const matchOrders = matchSequence.playoff[teamPlayoffRoundCount]

  // loop the 
  _.forEach(matchOrders, (matchOrder, index) => {
    const matchNumber = index + 1

    // homeSeed, awaySeed, workSeed
    const homeSeed = matchOrder[0]
    const awaySeed = matchOrder[1]
    const workSeed = matchOrder[2]
    const isConsolation = matchOrder[3] ? true : false

    // always 3 matchOrder (home, away, work)
    const homeTeam = getPoolTeamInfo(pool, homeSeed)
    const awayTeam = getPoolTeamInfo(pool, awaySeed)
    const workTeam = getPoolTeamInfo(pool, workSeed)

    // create the match
    const match = {
      name: pool.poolKey ? pool.poolKey : 'match',
      poolKey: pool.poolKey,
      roundKey: round.roundKey,
      matchKey: round.roundKey + '-' + pool.poolKey + '-' + matchNumber,
      matchNumber: matchNumber,
      seeds: {
        away: awayTeam.seed,
        home: homeTeam.seed,
      },
      isFirstRound: firstRound === pool?.poolKey
    }

    // update the work team
    if (!tournament.isPlayoff) {
      match.seeds.work = workTeam.seed
    }

    // update the startDate
    if (pool.startDate) {
      match.startDate = pool.startDate
      match.startTime = '7:00 PM'
    }

    if (tournament.levels) {
      match.levels = tournament.levels
    }

    match.isPlayoff = true

    if (isConsolation) {
      match.isConsolation = isConsolation
    }

    // add a match to the poolMatches 
    poolMatches['match' + (index + 1)] = match
  })


  return poolMatches

}

/*************************** */

const ammendPlayoffInfo = (roundInfo, maxPlayoffTeams, seededTeams) => {

  let max_teams = maxPlayoffTeams ? maxPlayoffTeams : (seededTeams ? seededTeams.length : 0);

  switch (true) {
    case max_teams > 16 && max_teams <= 32:
      max_teams = 32
      break;
    case max_teams > 8 && max_teams <= 16:
      max_teams = 16
      break;
    case max_teams > 4 && max_teams <= 8:
      max_teams = 8
      break;
    case max_teams > 3 && max_teams <= 4:
      max_teams = 4
      break;
    default:
    // nothing
  }

  roundInfo['playoffs'] = {
    maxTeams: max_teams ? max_teams : 16,
    setsPerMatch: 3,
    pointsPerSet: 25,
    bestOf: true,
    isPlayoff: true,
    isInitialPool: false,
    teams: seededTeams,
    tournamentTeamCount: max_teams ? max_teams : 16,
  }
}

const getPlayoffMatches = (database_fns, tournaments) => {

  const playoffMatches = {};
  const tournamentMatches = {};

  _.forEach(tournaments, (tournament, tournamentKey) => {
    tournamentMatches[tournamentKey] = {};

    _.forEach(tournament.rounds, (round) => {
      _.forEach(round?.pools, (pool) => {
        _.forEach(pool?.matches, (match) => {
          const _matchKey = database_fns.get_docKey('tournamentMatch');
          dataFix.deleteEmptyObjectValues(match);
          match._itemKey = _matchKey;
          playoffMatches[_matchKey] = match;
          tournamentMatches[tournamentKey][_matchKey] = match;
        });
      });
    });
  });

  return { playoffMatches, tournamentMatches };

}

const appendTournamentMatches_pending2 = (tournaments, playoffMatches) => {

  if (tournaments) {
    Object.keys(tournaments).forEach(tk => {
      const tournament = tournaments[tk]
      const { rounds } = tournament ?? {}
      if (rounds) {
        Object.keys(rounds).forEach(rk => {
          const round = rounds[rk]
          const { pools } = round ?? {}
          if (pools) {
            Object.keys(pools).forEach(pk => {
              const pool = pools[pk]
              const { matches } = pool ?? {}
              const matchRemoves = []
              if (matches) {
                Object.keys(matches).forEach(mk => {
                  const match = matches[mk]
                  const { pending } = match ?? {}
                  if (pending) {

                    const { home, away } = pending

                    const match_home = getOriginalMatch(tk, playoffMatches, home.originalSeed)
                    const match_away = getOriginalMatch(tk, playoffMatches, away.originalSeed)

                    const match_home0 = match_home && match_home.length === 1 ? match_home[0] : null
                    const match_away0 = match_away && match_away.length === 1 ? match_away[0] : null

                    const { away: home_away } = match_home0 ?? {}
                    const { away: away_away } = match_away0 ?? {}

                    if (home_away && home_away.name === 'BYE') {
                      match.home = match_home0.home
                      matchRemoves.push(mk)
                    }

                    if (away_away && away_away.name === 'BYE') {
                      match.away = match_away0.home
                      matchRemoves.push(mk)
                    }
                  }
                })
              }
              // matchRemoves.forEach(mr => {
              //   delete pool.matches[mr] 
              // })
            })
          }
        })
      }
    })
  }
}


const getOriginalMatch = (levels, playoffMatches, originalSeed) => _.filter(playoffMatches, function (pm) {
  const { home } = pm
  return levels === pm.levels && home && (
    home.seed === originalSeed);
})
